<template>
  <div class="chat-widget">
    <section class="chat-app-window">
      <vue-perfect-scrollbar
        ref="refChatLogPS"
        :settings="perfectScrollbarSettings"
        class="user-chats scroll-area"
      >
        <div class="chats">
          <div
            v-for="(coment, index) in comentarios"
            :key="coment.contaId + String(index)"
            class="chat"
            :class="{
              'chat-left': coment.pessoa.id !== authUser.contaId,
            }"
          >
            <div class="chat-avatar">
              <b-avatar
                size="32"
                class="avatar-border-2 box-shadow-1"
              >
                <feather-icon :icon="getIcon(coment.pessoa.id)" />
              </b-avatar>
            </div>
            <div class="chat-body">
              <div class="chat-content">
                <b>{{ getConta(coment.pessoa.id) }} </b>
                <p>
                  {{ coment.descricao }}
                </p>
                <b-badge variant="primary">{{
                  new Date(coment.dataHoraEvento) | formatDatetime
                }}</b-badge>
              </div>
            </div>
          </div>
        </div>
      </vue-perfect-scrollbar>
      <validation-observer ref="regras">
        <b-form
          class="chat-app-form"
          @submit.prevent="onGravar"
        >
          <b-input-group class="input-group-merge form-send-message ">
            <validation-provider
              name="Informe o Comentário"
              rules="required"
              class="w-100"
            >
              <b-form-input
                v-model="comentario.texto"
                name="comentário"
                placeholder="Digite seu comentário"
              />
            </validation-provider>
          </b-input-group>

          <b-button
            variant="primary"
            type="submit"
          >
            Enviar
          </b-button>
        </b-form>
      </validation-observer>
    </section>
  </div>
</template>

<script>
import {
  BFormInput, BAvatar, BInputGroup, BForm,
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'

export default {
  name: 'ComentariosOcorrencia',
  components: {
    ValidationProvider,
    ValidationObserver,
    VuePerfectScrollbar,
    BAvatar,
    BFormInput,
    BForm,
    BInputGroup,
  },
  props: {
    ocorrencia: Object,
  },
  data() {
    return {
      perfectScrollbarSettings: {
        maxScrollbarLength: 150,
        wheelPropagation: false,
      },
      required,

      comentario: {
        texto: null,
      },
    }
  },
  computed: {
    authUser() {
      const user = this.$store.getters['auth/authUser']()
      return user
    },
    comentarios() {
      return this.$store.state.livroOcorrencia.eventos
    },
  },
  beforeCreate() {
    this.$store.dispatch('livroOcorrencia/clearEventos')
  },
  created() {
    this.fetchEventos()
  },
  methods: {
    fetchEventos() {
      this.$store.dispatch('livroOcorrencia/fetchEventos', {
        ocorrencia: this.ocorrencia,
      })
    },
    getConta(contaId) {
      if (this.authUser.contaId === contaId) {
        return this.authUser.primeiroNome
      }
      if (contaId === 0) {
        return 'Informativo'
      }
      return contaId
    },
    getIcon(contaId) {
      if (this.authUser.contaId === contaId) {
        return 'UserIcon'
      }
      if (contaId === 0) {
        return 'CloudIcon'
      }
      return 'UsersIcon'
    },
    onGravar() {
      this.$refs.regras.validate().then(result => {
        if (result) {
          this.$store
            .dispatch('livroOcorrencia/saveEvento', {
              ocorrencia: { id: this.ocorrencia.id },
              dataHoraEvento: new Date(),
              descricao: this.comentario.texto,
            })
            .then(() => {
              this.comentario = {}
              this.fetchEventos()
              this.showSuccess('Comentário gravado com sucesso.')
            })
            .catch(err => {
              this.showError(err)
            })
        }
      })
    },
    showError(err) {
      this.$toast.error(err.response ? err.response.data.error : err)
    },
    showSuccess(msg) {
      this.$toast.success(msg)
    },
  },
}
</script>

<style lang="scss">
@import '~@core/scss/base/pages/app-chat.scss';
@import '@core/scss/base/pages/app-chat-list.scss';
</style>
